import React, { useContext } from 'react';
import Alert from '@mui/material/Alert';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import { MessageInputContext } from './MessageInputContext';
import stripHTMLTagsFromString from 'venuescanner-js/react/components/Inbox/helpers/stripHTMLTagsFromString';

import CtaAttachFile from 'venuescanner-js/react/components/Inbox/components/Objects/Ctas/CtaAttachFile';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
// need to import scss here, not in index.js, as otherwise it doesn't apply to the component
import './MessageInput.scss';

const MessageInput = ({ actionTriggers, inboxMaxHeight, ...props }) => {
  const { isUserTyping } = useContext(ViewContext);
  const {
    toggleInput,
    messageInputText,
    attached,
    setAttached,
    errorMessage,
    setErrorMessage,
  } = useContext(MessageInputContext);

  const parsePastedContent = e => {
    e.preventDefault();
    const parsedContent = stripHTMLTagsFromString(e.clipboardData.getData('text'));
    document.execCommand('insertText', false, parsedContent);
  };

  const onAttached = async attachments => {
    const attachedItems = [...attached];
    if (attachments && attachments.values && attachments.values.length) {
      JSON.parse(JSON.stringify(attachments)).forEach(item =>
        attachedItems.push(item),
      );
    }
    setAttached(attachedItems);
    toggleInput(true);
  };

  const removeFileFromAttachments = attachmentToRemove => {
    const attachedItems = [...attached];
    setAttached(
      attachedItems.filter(
        attachment => attachment._id !== attachmentToRemove._id,
      ),
    );
  };

  const attachments = attached.map((attachment, index) => {
    return (
      <Stack
        pt={1}
        spacing={0.5}
        direction='row'
        alignItems='flex-end'
        key={attachment.filename + index}>
        <FilePresentOutlinedIcon fontSize='small' htmlColor='#000' />
        <Box component='span' mx={1}>
          {attachment.filename.replace(
            /([^\\]{5})[^\\]+?([^\\]{0})$/,
            '$1...$2',
          )}
        </Box>
        <IconButton
          sx={{ p: 0.125, alignSelf: 'top' }}
          size='small'
          onClick={() => removeFileFromAttachments(attachment)}>
          <CloseIcon fontSize='small' htmlColor='#979797' />
        </IconButton>
      </Stack>
    );
  });

  return (
    <Stack direction='column'>
      {errorMessage && (
        <Alert
          severity='error'
          style={{ width: '90%', margin: '0 5%' }}
          onClose={() => setErrorMessage(null)}>
          {errorMessage}{' '}
        </Alert>
      )}
      <Stack
        direction='column'
        spacing={2}
        className='message-input'
        {...props}>
        <div
          className={`message-input__element ${
            !isUserTyping && 'message-input__element--minified'
          }`}>
          <div
            className='message-input__wrapper'
            onClick={() => !isUserTyping && toggleInput(true)}>
            <p
              ref={messageInputText}
              className='message-input__text'
              contentEditable='true'
              role='textbox'
              tabIndex='0'
              style={{ maxHeight: inboxMaxHeight }}
              onPaste={e => parsePastedContent(e)}
            />
            {isUserTyping && <Stack spacing={0}>{attachments}</Stack>}
            {!isUserTyping && (
              <p className='message-input__placeholder'>Send quick reply...</p>
            )}
          </div>
        </div>
        <Stack
          direction='row'
          spacing={1}
          style={{ padding: 0, marginTop: '0.5 rem' }}>
          <CtaAttachFile onAttached={onAttached} />
          {actionTriggers ? <Divider orientation='vertical' flexItem /> : null}
          {actionTriggers}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MessageInput;
